<template>
    <div>
        <div class="row">
            <recent-releases/>
        </div>
        <div class="container-fluid home-container">
            <div class="row">
                <div class="col-md-2 top-downloads">
                    <top-downloads/>
                </div>
                <div class="col-md-9 recently-reviewed-container">
                    <h3>Recently Reviewed</h3>
                    <div class="row" v-for="row in maps">
                        <div class="col-md-4" v-for="map in row" :key="map._id">
                            <map-card :map="map" />
                        </div>
                    </div>
                    <br/>
                    <pagination v-model="currentPage" :total-page="totalPages" @change="changePage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RecentReleases from './RecentReleases'
import TopDownloads from './TopDownloads'
import Callout from './Callout'
import MapCard from './MapCard'
import { Pagination } from 'uiv'
import { api } from '../framework/api'
import { store } from '../framework/store'
import _ from 'lodash'

export default {
    components: { RecentReleases, TopDownloads, Callout, MapCard, Pagination },
    data() {
        return {
            maps: [],
            currentPage: 1,
            totalPages: 0
        }
    },
    methods: {
        changePage(page) {
            this.currentPage = page;
            this.search();
        },
        async search() {
            let results = await api.get(`reviews?status=Submitted&cdMap=false&page=${this.currentPage}&pageSize=24`);
            this.totalPages = results.data.pages;
            this.maps = _.chunk(results.data.data, 3);
        }
    },
    async created() {
        this.search();
    }
}
</script>

<style scoped>
.home-container {
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue